<template>
  <div class="page">
    <!-- 统一风格页头 -->
    <div class="page-header">
      <div class="header-left">
        <h1 class="page-title">學習排行榜</h1>
      </div>
      <div class="header-right">
        <!-- 可根据需求添加导出按钮 -->
      </div>
    </div>

    <div class="layout">
      <!-- 标签页区域 -->
      <div class="tabs-container">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick" size="small">
          <el-tab-pane label="冒險模式" name="first"></el-tab-pane>
          <el-tab-pane label="圖書館模式" name="second"></el-tab-pane>
        </el-tabs>
      </div>

      <!-- 统一风格搜索区 -->
      <div class="search-card">
        <!-- 修复：修改 search-row 布局，移动端垂直排列 -->
        <div class="search-row">
          <el-select
              size="small"
              v-if="userInfoRoleRoleId !== teacherRoleId"
              v-model="listQuery.branchSchoolId"
              placeholder="請選擇分校"
              filterable
              ref="branchSchoolSelect"
              :filter-method="filterBranchSchool"
              clearable
          >
            <el-option
                v-for="(item) in filteredBranchSchools"
                :key="item.id"
                :label="`${item.abbreviation || ''}${item.nameZh || ''}`"
                :value="item.id"
                :title="`${item.abbreviation || ''}${item.nameZh || ''}`"
            ></el-option>
          </el-select>
          <el-input
              size="small"
              v-model="listQuery.userNoLike"
              placeholder="學生帳號"
              prefix-icon="el-icon-user"
              clearable
          ></el-input>

          <el-select
              size="small"
              v-model="listQuery.gradeId"
              clearable
              placeholder="年級"
          >
            <el-option
                size="small"
                v-for="(item, index) in grades"
                :key="index"
                :label="item.name"
                :value="item.id"
            ></el-option>
          </el-select>

          <el-select
              size="small"
              v-model="listQuery.lang"
              placeholder="課程版本"
              clearable
          >
            <el-option
                size="small"
                key="0"
                label="繁體"
                value="0"
            ></el-option>
            <el-option
                key="1"
                label="English"
                value="1"
            ></el-option>
          </el-select>

          <el-date-picker
              style="width: 226px;"
              size="small"
              clearable
              v-model="listQuery.dateValue"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="做題開始日期"
              end-placeholder="做題截止日期"
              :picker-options="pickerOptions"
          ></el-date-picker>

          <el-select
              size="small"
              v-model="listQuery._limit"
              placeholder="前幾名"
              clearable
          >
            <el-option label="前10名" value="10"></el-option>
            <el-option label="前100名" value="50"></el-option>
            <el-option label="前100名" value="100"></el-option>
            <el-option label="前300名" value="300"></el-option>
            <el-option label="前500名" value="500"></el-option>
            <el-option label="前1000名" value="1000"></el-option>
          </el-select>

          <div class="search-buttons">
            <el-button size="small" type="warning" @click.native="onSearch" icon="el-icon-search">搜尋</el-button>
            <el-button size="small" @click="onReset" icon="el-icon-refresh">重置</el-button>
          </div>
        </div>
      </div>

      <!-- 统一风格 PC表格 + 手机卡片 -->
      <div class="table-container">
        <!-- PC端表格（≥768px显示） -->
        <div class="pc-table">
          <el-table
              v-loading="loading"
              @sort-change="handleSortChange"
              :data="tableData"
              style="width: 100%;"
              border
              stripe
              size="small"
              :empty-text="tableData.length === 0 && !loading ? '暫無排行榜數據' : ''"
          >
            <el-table-column label="排名" prop="ranking" width="60" align="center"> </el-table-column>
            <el-table-column prop="branchSchoolId" label="分校" align="center" sortable="custom" min-width="80">
              <template slot-scope="{ row }">
                <span v-if="row.branchSchool">{{ row.branchSchool.abbreviation }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="gradeId" label="年級" align="center" sortable="custom" min-width="80">
              <template slot-scope="{ row }">
                <span v-if="row.grade">{{ row.grade.name }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column
                prop="userNo"
                label="學生帳號"
                align="center"
                sortable="custom"
                min-width="100"
            ></el-table-column>
            <el-table-column
                prop="name"
                label="學生姓名"
                align="center"
                sortable="custom"
                min-width="100"
            ></el-table-column>
            <el-table-column
                prop="studying"
                label="課程版本"
                align="center"
                sortable="custom"
                width="80"
            >
              <template slot-scope="{row}">
                <span>{{row.studying==0?'繁':'En'}}</span>
              </template>
            </el-table-column>
            <el-table-column
                v-if="activeName=='first'"
                prop="stars"
                label="星星總數（大蛋）"
                align="center"
                sortable="custom"
                min-width="120"
            >
              <template slot-scope="{row}">
                <span>{{row.stars || 0}}</span>
              </template>
            </el-table-column>
            <el-table-column
                v-if="activeName=='second'"
                prop="stars"
                label="細蛋總數"
                align="center"
                sortable="custom"
                min-width="100"
            >
              <template slot-scope="{row}">
                <span>{{row.stars || 0}}</span>
              </template>
            </el-table-column>
            <el-table-column
                prop="overallPerformance"
                label="答對率"
                align="center"
                sortable="custom"
                min-width="80"
            >
              <template slot-scope="{row}">
                <span>{{row.overallPerformance}}%</span>
              </template>
            </el-table-column>
            <el-table-column
                prop="subCorrectQuantity"
                label="答對數/總答題數"
                align="center"
                sortable="custom"
                min-width="120"
            >
              <template slot-scope="{row}">
                <span>{{row.subCorrectQuantity || 0}}/{{row.subScore || 0}}</span>
              </template>
            </el-table-column>
            <el-table-column
                prop="totalAnsweringMinutes"
                label="答題時長(分鐘)"
                align="center"
                sortable="custom"
                min-width="100"
            >
              <template slot-scope="{row}">
                <span>{{row.totalAnsweringMinutes || 0}}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 手机端卡片列表（<768px显示） -->
        <div class="mobile-cards">
          <div class="user-card" v-for="(item) in tableData" :key="item.id">
            <!-- 卡片头部：排名 + 姓名 + 模式标签 -->
            <div class="card-header">
              <div class="rank-badge">{{ item.ranking }}</div>
              <div class="user-name">{{ item.name }}</div>
              <el-tag size="mini" :type="activeName === 'first' ? 'warning' : 'info'">
                {{ activeName === 'first' ? '冒險模式' : '圖書館模式' }}
              </el-tag>
            </div>

            <!-- 卡片主体：核心信息 -->
            <div class="card-body">
              <div class="info-item">
                <span class="info-label">分校：</span>
                <span class="info-value">{{ item.branchSchool?.abbreviation || '未填寫' }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">年級：</span>
                <span class="info-value">{{ item.grade?.name || '未填寫' }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">學生帳號：</span>
                <span class="info-value">{{ item.userNo || '未填寫' }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">課程版本：</span>
                <span class="info-value">{{ item.studying==0?'繁體':'English' }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">{{ activeName === 'first' ? '星星總數：' : '細蛋總數：' }}</span>
                <span class="info-value">{{ item.stars || 0 }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">答對率：</span>
                <span class="info-value">{{ item.overallPerformance || '0%' }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">答對數/總數：</span>
                <span class="info-value">{{ item.subCorrectQuantity || 0 }}/{{ item.subScore || 0 }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">答題時長：</span>
                <span class="info-value">{{ item.totalAnsweringMinutes || 0 }} 分鐘</span>
              </div>
            </div>
          </div>

          <!-- 空数据提示 -->
          <div class="empty-tip" v-if="tableData.length === 0 && !loading">
            暫無排行榜數據
          </div>
        </div>
      </div>
    </div>

    <!-- 分页（保留原有逻辑，按需显示） -->
<!--    <div class="pagination-wrap">-->
<!--      <Pagination-->
<!--          v-show="total > 0"-->
<!--          :total="total"-->
<!--          :page.sync="listQuery._page"-->
<!--          :limit.sync="listQuery._limit"-->
<!--          @pagination="onSearch"-->
<!--      />-->
<!--    </div>-->
  </div>
</template>

<script>
import { getLearningRankingList } from "@/api/users";
import { getGrades } from '@/api/grade';

export default {
  filters: {
    studentCodeStatus(v) {
      return v === 0 ? "封鎖" : "生效";
    },
    subscriptionStatus(v) {
      return v === 0 ? "無訂閱" : v === 1 ? "訂閱中" : v === 2 ? "過期" : "等待開始";
    },
  },
  data() {
    return {
      activeName: 'first',
      loading: true,
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一個月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三個月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近半年',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30 * 6);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一年',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30 * 12);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      filteredBranchSchools: [],
      selectedRows: [],
      total: 0,
      userId: null,
      listQuery: {
        userNoLike: null,
        nameLike: null,
        parentEmailLike: null,
        studentCodeLike: null,
        gender: null,
        lang: '0',
        gradeId: 1,
        objectType: 1,
        dateValue: '',
        orderBy: null,
        _page: 1,
        _limit: "10",
      },
      centerDialogVisible: false,
      dialogSlotVisible: false,
      tableData: [],
      avatars: [],
      grades: [],
      form: {
        ids: null
      },
      // 补充角色ID变量（根据实际业务调整）
      adminUserInfoRoleId: this.$store.getters.userInfo?.roleId || '',
      teacherRoleId: 2 // 假设教师角色ID为2，需根据实际值调整
    };
  },
  created() {
    this.getUsers();
    this.getGrades();
    // 初始化时加载全部校区列表
    this.filteredBranchSchools = this.$store.getters.branchSchools || [];
  },
  methods: {
    // 自定义筛选方法：根据输入关键词匹配校区缩写
    filterBranchSchool(val) {
      // 1. 兜底获取分校列表，避免 null/undefined
      const branchSchools = this.$store.getters.branchSchools || [];

      if (!val) {
        // 输入为空时显示全部
        this.filteredBranchSchools = branchSchools;
      } else {
        // 2. 统一转小写+去除首尾空格，保证匹配一致性
        const searchText = val.toLowerCase().trim();

        // 3. 同时匹配 abbreviation 和 nameZh（都做空值兜底）
        this.filteredBranchSchools = branchSchools.filter(item => {
          // 空值兜底：避免 item.abbreviation/nameZh 为 null/undefined 时报错
          const abbreviation = (item.abbreviation || '').toLowerCase();
          const nameZh = (item.nameZh || '').toLowerCase();
          const nameEn = (item.nameEn || '').toLowerCase();
          // 满足任意一个字段匹配即可
          return abbreviation.includes(searchText) || nameZh.includes(searchText) || nameEn.includes(searchText);
        });
      }
    },
    handleClick() {
      this.onSearch();
    },
    getGrades() {
      getGrades().then((res) => {
        this.grades = res.data || [];
      }).catch(err => {
        console.error('獲取年級列表失敗：', err);
        this.$message.error('獲取年級列表失敗，請稍後重試');
      });
    },
    handleSortChange(column) {
      this.listQuery.orderBy = column.order ? `${column.prop} ${column.order === "descending" ? "desc" : "asc"}` : null;
      this.listQuery._page = 1;
      this.getUsers();
    },
    onSearch() {
      this.listQuery._page = 1;
      this.getUsers();
    },
    onReset() {
      Object.keys(this.listQuery).forEach((key) => {
        this.listQuery[key] = null;
        if (key === "_page") {
          this.listQuery[key] = 1;
        } else if (key === "_limit") {
          this.listQuery[key] = 10;
        } else if (key === "lang") {
          this.listQuery[key] = '0'; // 重置语言为繁体
        } else if (key === "gradeId") {
          this.listQuery[key] = 1; // 重置年级为小一
        }
      });
      // 重置校区筛选列表
      this.filteredBranchSchools = this.$store.getters.branchSchools || [];
      this.getUsers();
    },
    getUsers() {
      this.loading = true;
      if (this.activeName === 'first') {
        // 冒險模式
        this.listQuery.objectType = 1;
      } else {
        // 圖書館模式
        this.listQuery.objectType = 0;
      }
      let listQuery = {
        type: 2,
        userNoLike: this.listQuery.userNoLike,
        nameLike: this.listQuery.nameLike,
        objectType: this.listQuery.objectType,
        parentEmailLike: this.listQuery.parentEmailLike,
        studentCodeLike: this.listQuery.studentCodeLike,
        branchSchoolId: this.listQuery.branchSchoolId,
        lang: this.listQuery.lang,
        startDate: this.convertToDateTimeStr(this.listQuery.dateValue?.[0], 0), // 开始日期（Date 对象）
        endDate: this.convertToDateTimeStr(this.listQuery.dateValue?.[1], 1),   // 结束日期（Date 对象）
        gender: this.listQuery.gender,
        gradeId: this.listQuery.gradeId,
        orderBy: this.listQuery.orderBy,
        _page: this.listQuery._page - 1,
        _limit: this.listQuery._limit,
      };
      // 清空空值参数
      Object.keys(listQuery).forEach(key => {
        if (listQuery[key] === null || listQuery[key] === undefined) {
          delete listQuery[key];
        }
      });
      getLearningRankingList(listQuery).then((v) => {
        this.tableData = v.data || [];
        this.total = Number(v.headers["x-total-count"]) || 0;
        this.loading = false;
      }).catch(err => {
        console.error('獲取排行榜數據失敗：', err);
        this.tableData = [];
        this.total = 0;
        this.loading = false;
      });
    },
    convertToDateTimeStr(isoStr, type) {
      if (!isoStr) {
        return null;
      }
      // 转换函数：ISO字符串 → yyyy-MM-dd HH:mm:ss（本地时区）
      const date = new Date(isoStr);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      // 提取本地时区的时、分、秒（补0）
      if (type === 0) {
        return `${year}-${month}-${day} 00:00:00`;
      } else {
        return `${year}-${month}-${day} 23:59:59`;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.page {
  padding: 16px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}

/* 统一风格页头 */
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e4e7ed;

  .header-left {
    .page-title {
      font-size: 20px;
      font-weight: 600;
      color: #B62D2E;
      margin: 0 0 4px 0;
    }
  }

  .header-right {
    .el-button {
      padding: 8px 16px;
    }
  }
}

/* 布局容器 */
.layout {
  background: #fff;
  border-radius: 8px;
  //padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  //margin-bottom: 16px;
}

/* 标签页容器 */
.tabs-container {
  margin-bottom: 16px;
  ::v-deep .el-tabs--card {
    --el-tabs-card-header-background: #f8f9fa;
    --el-tabs-active-color: #409eff;
  }
}

/* 统一风格搜索卡片 */
.search-card {
  background: #f8f9fa;
  padding: 16px;
  border-radius: 6px;
  margin-bottom: 20px;

  /* 修复：PC端水平排列，移动端垂直排列 */
  .search-row {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    align-items: center;

    /* 修复：移除 min-width，改为 width: 100% 配合 flex */
    .el-input, .el-select, .el-date-picker {
      flex: 1;
      width: 100%; /* 关键修复：强制宽度100% */
      min-width: unset; /* 移除原有 min-width */
    }

    .search-buttons {
      display: flex;
      gap: 8px;
      flex-shrink: 0; /* 按钮不收缩 */
    }
  }
}

/* 表格/卡片容器 */
.table-container {
  width: 100%;

  /* PC端表格样式 */
  .pc-table {
    ::v-deep .el-table {
      --el-table-header-text-color: #4e5969;
      --el-table-row-hover-bg-color: #f8f9fa;
    }

    ::v-deep .el-table th {
      background: #f8f9fa;
      font-weight: 600;
    }

    ::v-deep .cell {
      color: #1f2937;
    }
  }

  /* 手机端卡片列表样式 */
  .mobile-cards {
    display: none;
    gap: 12px;
    flex-direction: column;

    .user-card {
      background: #fff;
      border: 1px solid #e9ecef;
      border-radius: 8px;
      padding: 16px;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

      /* 卡片头部：排名+姓名+标签 */
      .card-header {
        display: flex;
        align-items: center;
        margin-bottom: 12px;
        position: relative;

        .rank-badge {
          width: 28px;
          height: 28px;
          line-height: 28px;
          text-align: center;
          background: #409eff;
          color: white;
          border-radius: 50%;
          font-weight: 600;
          margin-right: 12px;
        }

        .user-name {
          font-size: 16px;
          font-weight: 600;
          color: #1f2937;
          flex: 1;
        }
      }

      /* 卡片主体 */
      .card-body {
        margin-bottom: 0;

        .info-item {
          display: flex;
          margin-bottom: 8px;
          line-height: 1.5;

          .info-label {
            color: #6c757d;
            width: 80px;
            flex-shrink: 0;
          }

          .info-value {
            color: #1f2937;
            flex: 1;
            word-break: break-all;
          }
        }
      }
    }

    .empty-tip {
      text-align: center;
      padding: 32px;
      color: #999;
      font-size: 14px;
    }
  }
}

/* 分页样式 */
.pagination-wrap {
  text-align: center;
  ::v-deep .el-pagination {
    --el-pagination-button-bg-color: #fff;
    --el-pagination-button-hover-bg-color: #f8f9fa;
    --el-pagination-button-active-bg-color: #409eff;
  }
}

/* 响应式适配（和统一风格一致） */
@media (max-width: 768px) {
  .page {
    padding: 8px;
  }

  .page-header {
    padding: 12px 16px;
    flex-direction: column;
    align-items: flex-start;
  }

  .layout {
    //padding: 12px;
  }

  /* 修复：移动端搜索栏垂直排列，宽度100% */
  .search-card .search-row {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }

  /* 修复：移动端输入框宽度100%，无最小宽度 */
  .search-card .search-row .el-input,
  .search-card .search-row .el-select,
  .search-card .search-row .el-date-picker {
    width: 100% !important;
    min-width: unset !important;
  }

  /* 隐藏PC表格，显示手机卡片 */
  .table-container .pc-table {
    display: none;
  }
  .table-container .mobile-cards {
    display: flex;
  }
}
</style>